import { addPageLoadFieldsToLogEventIfNotAlreadyPresent } from '../api/middlewares/addPageLoadFieldsToLogEventIfNotAlreadyPresent';
import { addUserAgentToAnalyticsV2Event } from '../api/middlewares/addUserAgentToAnalyticsV2Event';
import { addVisibilityStateToLogEvent } from '../api/middlewares/addVisibilityStateToLogEvent';
import { TelemetryEvent } from '../events';

export type TelemetryMiddleware = (event: TelemetryEvent) => Promise<TelemetryEvent>;
const middlewares: TelemetryMiddleware[] = [
  addVisibilityStateToLogEvent,
  addUserAgentToAnalyticsV2Event,
  addPageLoadFieldsToLogEventIfNotAlreadyPresent,
];

export const applyMiddleware: TelemetryMiddleware = (event) =>
  middlewares.reduce(async (memoEvent, middleware) => middleware(await memoEvent), Promise.resolve(event));

export type AddMiddleware = (middleware: TelemetryMiddleware) => void;
export const addMiddleware: AddMiddleware = (middleware) => {
  middlewares.push(middleware);
};
